<template>
    <div class="row page-titles">
        <div class="col-sm-3 col-lg-4 align-self-center">
            <h4 class="text-themecolor">{{title}}</h4>
        </div>
        <div class="col-sm-5 col-lg-6 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link :to="{name: 'home'}">Home</router-link>
                    </li>
                    <li class="breadcrumb-item active">{{title}}</li>
                </ol>
            </div>
        </div>
        <slot>
            <router-link v-if="buttonShow" v-bind:to="{name: buttonUrl}" class="btn btn-info m-l-10">
                <i class="fa fa-plus-circle"></i> Create New
            </router-link>
        </slot>
    </div>
</template>

<script>
    export default {
        name: 'Breadcrumb',
        props: {
            title: String,
            buttonShow: {
                default: true
            },
            buttonUrl: {
                default: 'home'
            },
        }
    }
</script>

<style scoped>

</style>